import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Intervenez-vous chez les particuliers et les professionnels ?",
      answer: "Oui, absolument ! J'interviens auprès des particuliers, des professionnels (entreprises, commerces) et des copropriétés au Pays Basque. Mes deux activités (électricien et cordiste) sont proposées pour tous types de clientèle."
    },
    {
      question: "Quelles sont vos zones d'intervention au Pays Basque ?",
      answer: "Basé à Urrugne, j'interviens dans tout le Pays Basque : Bayonne, Biarritz, Anglet, Saint-Jean-de-Luz, Hendaye, Ciboure, Bidart, Guéthary, Ascain, Sare, et toutes les communes environnantes. Devis gratuit pour toute demande."
    },
    {
      question: "Proposez-vous les deux services en même temps ?",
      answer: "Oui ! Je peux intervenir uniquement en tant qu'électricien, uniquement en tant que cordiste, ou combiner les deux métiers pour des projets nécessitant des travaux électriques en hauteur. Cette polyvalence vous permet d'avoir un seul interlocuteur."
    },
    {
      question: "Êtes-vous disponible pour les dépannages urgents ?",
      answer: "Oui, je suis disponible 7j/7 pour tous vos dépannages électriques urgents au Pays Basque. Intervention rapide à Urrugne, Bayonne, Biarritz et environs. Contactez-moi au 06 10 95 26 31."
    },
    {
      question: "Vos devis sont-ils gratuits ?",
      answer: "Oui, tous mes devis sont totalement gratuits et sans engagement, que ce soit pour des travaux d'électricité, des travaux en hauteur, ou une combinaison des deux. Je me déplace gratuitement pour évaluer vos besoins."
    },
    {
      question: "Quelles sont vos qualifications ?",
      answer: "Je suis électricien qualifié et cordiste professionnel certifié. Je respecte toutes les normes en vigueur (NF C 15-100 pour l'électricité) et les normes de sécurité pour les travaux en hauteur."
    },
    {
      question: "Que comprend le service de relamping ?",
      answer: "Le relamping consiste au remplacement et à la maintenance d'éclairages en hauteur (lampadaires, éclairages de façade, enseignes) par accès sur corde. C'est une solution économique et rapide sans nécessiter d'échafaudage ou de nacelle."
    },
    {
      question: "Travaillez-vous sur des chantiers de construction neuve ?",
      answer: "Oui, j'interviens sur des travaux neufs pour l'installation électrique complète de maisons, appartements et locaux professionnels au Pays Basque. Je peux également réaliser des travaux en hauteur simultanément si nécessaire."
    }
  ];

  return (
    <section className="py-20 bg-slate-950">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Questions Fréquentes
            </h2>
            <p className="text-xl text-slate-400">
              Tout ce que vous devez savoir sur mes services au Pays Basque
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-xl overflow-hidden hover:border-blue-500/50 transition-all duration-300"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-slate-800/70 transition-colors"
                >
                  <span className="text-lg font-semibold text-white pr-8">
                    {faq.question}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 text-blue-400 flex-shrink-0 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                
                {openIndex === index && (
                  <div className="px-6 pb-5 animate-in fade-in slide-in-from-top-2 duration-300">
                    <p className="text-slate-300 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-slate-400 mb-4">
              Vous ne trouvez pas la réponse à votre question ?
            </p>
            <a
              href="tel:0610952631"
              className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 font-semibold transition-colors"
            >
              Appelez-moi au 06 10 95 26 31
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
